import Grid from '@/global/components/ui/Grid'
import { FormDatePicker, FormFieldSelect } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import {
    CreateTabelaHorarioFuncionarioSchema,
    funcionario,
    tabelaHorarios,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

interface Props {
    open: boolean
    onClose: () => void
    /** Dia pré-selecionado no calendário, em `YYYY-MM-DD`. */
    dtInicial?: string | null
}

export function AdicionarTabelaHorarioFuncionario({
    onClose,
    open,
    dtInicial,
}: Props) {
    const funcionarioId = useStore(state => state.employeeId),
        empresaId = useStore(state => state.companyId)
    const { data } = tabelaHorarios.useFetch()
    const { mutateAsync, isLoading } =
        tabelaHorarios.funcionario.mutations.useCreate({
            invalidateQuery: true,
        })

    function handleSubmit(values: any) {
        return mutateAsync(
            { ...values, empresaId, funcionarioId },
            {
                onSuccess: () => {
                    toast.success('Funcionário atualizado com sucesso!')
                    funcionario.invalidateQueries()
                },

                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return [
        <Dialog.Root
            open={hasPermission(['update', 'Funcionários']) && open}
            onClose={onClose}
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={CreateTabelaHorarioFuncionarioSchema}
            defaultValues={{
                empresaId,
                funcionarioId,
                dtInicial: dtInicial ?? undefined,
            }}
        >
            <Dialog.Title>Troca de tabela de horário</Dialog.Title>
            <Dialog.Content>
                <Grid container>
                    <Grid item xs={12}>
                        <FormFieldSelect
                            label="Tabela de horário"
                            name="tabelaHorarioId"
                            required
                            options={
                                data?.map(tabela => ({
                                    label: tabela.nome,
                                    value: tabela.id.toString(),
                                })) ?? []
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormDatePicker
                            label="Data inicial"
                            name="dtInicial"
                            type="date"
                            required
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormDatePicker
                            label="Data final"
                            name="dtFinal"
                            type="date"
                            helperText="Deixe em branco para indeterminado"
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>,
    ]
}
